exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".book img[data-v-577d49ae]{width:100%;height:100%}.book p[data-v-577d49ae]{position:absolute;bottom:0;width:100%;text-align:center;height:50px;font-size:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-577d49ae","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 18
// module chunks = 0